var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./Excel-icon.svg": "./src/icons/svg/Excel-icon.svg",
	"./IndustryCount1.svg": "./src/icons/svg/IndustryCount1.svg",
	"./USA.svg": "./src/icons/svg/USA.svg",
	"./address-list.svg": "./src/icons/svg/address-list.svg",
	"./ai-white-start.svg": "./src/icons/svg/ai-white-start.svg",
	"./aiChat/airebot.svg": "./src/icons/svg/aiChat/airebot.svg",
	"./aiChat/answer/copy.svg": "./src/icons/svg/aiChat/answer/copy.svg",
	"./aiChat/answer/dislike.svg": "./src/icons/svg/aiChat/answer/dislike.svg",
	"./aiChat/answer/like.svg": "./src/icons/svg/aiChat/answer/like.svg",
	"./aiChat/beta.svg": "./src/icons/svg/aiChat/beta.svg",
	"./aiChat/changetype.svg": "./src/icons/svg/aiChat/changetype.svg",
	"./aiChat/check_contacts_data.svg": "./src/icons/svg/aiChat/check_contacts_data.svg",
	"./aiChat/check_statistic.svg": "./src/icons/svg/aiChat/check_statistic.svg",
	"./aiChat/check_supplier.svg": "./src/icons/svg/aiChat/check_supplier.svg",
	"./aiChat/check_trade_data.svg": "./src/icons/svg/aiChat/check_trade_data.svg",
	"./aiChat/checked.svg": "./src/icons/svg/aiChat/checked.svg",
	"./aiChat/clickborder.svg": "./src/icons/svg/aiChat/clickborder.svg",
	"./aiChat/global.svg": "./src/icons/svg/aiChat/global.svg",
	"./aiChat/goto.svg": "./src/icons/svg/aiChat/goto.svg",
	"./aiChat/me.svg": "./src/icons/svg/aiChat/me.svg",
	"./aiChat/no_global.svg": "./src/icons/svg/aiChat/no_global.svg",
	"./aiChat/read_MS_Report.svg": "./src/icons/svg/aiChat/read_MS_Report.svg",
	"./aiChat/session/deldialog.svg": "./src/icons/svg/aiChat/session/deldialog.svg",
	"./aiChat/session/edittitle.svg": "./src/icons/svg/aiChat/session/edittitle.svg",
	"./aiChat/session/sticktop.svg": "./src/icons/svg/aiChat/session/sticktop.svg",
	"./aiChat/uncheck.svg": "./src/icons/svg/aiChat/uncheck.svg",
	"./amount.svg": "./src/icons/svg/amount.svg",
	"./analysis/delete.svg": "./src/icons/svg/analysis/delete.svg",
	"./analysis/down-black.svg": "./src/icons/svg/analysis/down-black.svg",
	"./analysis/down-blue.svg": "./src/icons/svg/analysis/down-blue.svg",
	"./analysis/down-xi.svg": "./src/icons/svg/analysis/down-xi.svg",
	"./analysis/file.svg": "./src/icons/svg/analysis/file.svg",
	"./analysis/folder.svg": "./src/icons/svg/analysis/folder.svg",
	"./analysis/magnifier.svg": "./src/icons/svg/analysis/magnifier.svg",
	"./analysis/pdf.svg": "./src/icons/svg/analysis/pdf.svg",
	"./analysis/ppt.svg": "./src/icons/svg/analysis/ppt.svg",
	"./analysis/right-black.svg": "./src/icons/svg/analysis/right-black.svg",
	"./analysis/right-red.svg": "./src/icons/svg/analysis/right-red.svg",
	"./analysis/time.svg": "./src/icons/svg/analysis/time.svg",
	"./analysis/up-blue.svg": "./src/icons/svg/analysis/up-blue.svg",
	"./analysis/videoIcon.svg": "./src/icons/svg/analysis/videoIcon.svg",
	"./analysis/xianshimianfei.svg": "./src/icons/svg/analysis/xianshimianfei.svg",
	"./analysis/yikaitong-en.svg": "./src/icons/svg/analysis/yikaitong-en.svg",
	"./analysis/yikaitong.svg": "./src/icons/svg/analysis/yikaitong.svg",
	"./asc-icon.svg": "./src/icons/svg/asc-icon.svg",
	"./back-top.svg": "./src/icons/svg/back-top.svg",
	"./big.svg": "./src/icons/svg/big.svg",
	"./billCollect.svg": "./src/icons/svg/billCollect.svg",
	"./boxCount.svg": "./src/icons/svg/boxCount.svg",
	"./business-icon.svg": "./src/icons/svg/business-icon.svg",
	"./business-nums.svg": "./src/icons/svg/business-nums.svg",
	"./business.svg": "./src/icons/svg/business.svg",
	"./businessData.svg": "./src/icons/svg/businessData.svg",
	"./buyer.svg": "./src/icons/svg/buyer.svg",
	"./cantonFair/business-home.svg": "./src/icons/svg/cantonFair/business-home.svg",
	"./cantonFair/guangjiaohui.svg": "./src/icons/svg/cantonFair/guangjiaohui.svg",
	"./ceshi.svg": "./src/icons/svg/ceshi.svg",
	"./changp.svg": "./src/icons/svg/changp.svg",
	"./chart-bar-active.svg": "./src/icons/svg/chart-bar-active.svg",
	"./chart-bar.svg": "./src/icons/svg/chart-bar.svg",
	"./chart-line-active.svg": "./src/icons/svg/chart-line-active.svg",
	"./chart-line.svg": "./src/icons/svg/chart-line.svg",
	"./checkTrade.svg": "./src/icons/svg/checkTrade.svg",
	"./china-flag.svg": "./src/icons/svg/china-flag.svg",
	"./close.svg": "./src/icons/svg/close.svg",
	"./collectCount.svg": "./src/icons/svg/collectCount.svg",
	"./company.svg": "./src/icons/svg/company.svg",
	"./company/address-icon.svg": "./src/icons/svg/company/address-icon.svg",
	"./company/ai-ex-help.svg": "./src/icons/svg/company/ai-ex-help.svg",
	"./company/arraw-left.svg": "./src/icons/svg/company/arraw-left.svg",
	"./company/cancel-fixed-position.svg": "./src/icons/svg/company/cancel-fixed-position.svg",
	"./company/change-lot.svg": "./src/icons/svg/company/change-lot.svg",
	"./company/collect-active-icon.svg": "./src/icons/svg/company/collect-active-icon.svg",
	"./company/copy-company.svg": "./src/icons/svg/company/copy-company.svg",
	"./company/credit-report-icon.svg": "./src/icons/svg/company/credit-report-icon.svg",
	"./company/detail-view-icon.svg": "./src/icons/svg/company/detail-view-icon.svg",
	"./company/en-company-name.svg": "./src/icons/svg/company/en-company-name.svg",
	"./company/export-new.svg": "./src/icons/svg/company/export-new.svg",
	"./company/fixed-position.svg": "./src/icons/svg/company/fixed-position.svg",
	"./company/follow-new.svg": "./src/icons/svg/company/follow-new.svg",
	"./company/hus1.svg": "./src/icons/svg/company/hus1.svg",
	"./company/hus2.svg": "./src/icons/svg/company/hus2.svg",
	"./company/hus3.svg": "./src/icons/svg/company/hus3.svg",
	"./company/inertia-en.svg": "./src/icons/svg/company/inertia-en.svg",
	"./company/inertia.svg": "./src/icons/svg/company/inertia.svg",
	"./company/link-graph.svg": "./src/icons/svg/company/link-graph.svg",
	"./company/links-group.svg": "./src/icons/svg/company/links-group.svg",
	"./company/merge-similar.svg": "./src/icons/svg/company/merge-similar.svg",
	"./company/search-check-icon.svg": "./src/icons/svg/company/search-check-icon.svg",
	"./company/share-new.svg": "./src/icons/svg/company/share-new.svg",
	"./company/tree-graph.svg": "./src/icons/svg/company/tree-graph.svg",
	"./company/uniE0F6.svg": "./src/icons/svg/company/uniE0F6.svg",
	"./company/video-teach.svg": "./src/icons/svg/company/video-teach.svg",
	"./company/whatsapp.svg": "./src/icons/svg/company/whatsapp.svg",
	"./companyCount.svg": "./src/icons/svg/companyCount.svg",
	"./contact.svg": "./src/icons/svg/contact.svg",
	"./contactCount.svg": "./src/icons/svg/contactCount.svg",
	"./count.svg": "./src/icons/svg/count.svg",
	"./country.svg": "./src/icons/svg/country.svg",
	"./countryAndArea.svg": "./src/icons/svg/countryAndArea.svg",
	"./crm.svg": "./src/icons/svg/crm.svg",
	"./crmGrey.svg": "./src/icons/svg/crmGrey.svg",
	"./crmRed.svg": "./src/icons/svg/crmRed.svg",
	"./csv.svg": "./src/icons/svg/csv.svg",
	"./customer-service.svg": "./src/icons/svg/customer-service.svg",
	"./customsDeclaration.svg": "./src/icons/svg/customsDeclaration.svg",
	"./dashbord/billCollectNew.svg": "./src/icons/svg/dashbord/billCollectNew.svg",
	"./dashbord/blue-bulb.svg": "./src/icons/svg/dashbord/blue-bulb.svg",
	"./dashbord/blue-heart.svg": "./src/icons/svg/dashbord/blue-heart.svg",
	"./dashbord/blue-start.svg": "./src/icons/svg/dashbord/blue-start.svg",
	"./dashbord/check-credit-report.svg": "./src/icons/svg/dashbord/check-credit-report.svg",
	"./dashbord/componentIcon1.svg": "./src/icons/svg/dashbord/componentIcon1.svg",
	"./dashbord/componentIcon2.svg": "./src/icons/svg/dashbord/componentIcon2.svg",
	"./dashbord/componentIcon3.svg": "./src/icons/svg/dashbord/componentIcon3.svg",
	"./dashbord/componentIcon4.svg": "./src/icons/svg/dashbord/componentIcon4.svg",
	"./dashbord/componentIcon5.svg": "./src/icons/svg/dashbord/componentIcon5.svg",
	"./dashbord/componentIcon6.svg": "./src/icons/svg/dashbord/componentIcon6.svg",
	"./dashbord/contact-search.svg": "./src/icons/svg/dashbord/contact-search.svg",
	"./dashbord/csv-download.svg": "./src/icons/svg/dashbord/csv-download.svg",
	"./dashbord/followCompanyNew.svg": "./src/icons/svg/dashbord/followCompanyNew.svg",
	"./dashbord/grid-rectangle-icon.svg": "./src/icons/svg/dashbord/grid-rectangle-icon.svg",
	"./dashbord/grid-rectangle.svg": "./src/icons/svg/dashbord/grid-rectangle.svg",
	"./dashbord/new-key-icon.svg": "./src/icons/svg/dashbord/new-key-icon.svg",
	"./dashbord/newMark.svg": "./src/icons/svg/dashbord/newMark.svg",
	"./dashbord/other-new.svg": "./src/icons/svg/dashbord/other-new.svg",
	"./dashbord/pinned-icon.svg": "./src/icons/svg/dashbord/pinned-icon.svg",
	"./dashbord/pushpin.svg": "./src/icons/svg/dashbord/pushpin.svg",
	"./dashbord/rate1.svg": "./src/icons/svg/dashbord/rate1.svg",
	"./dashbord/rate2.svg": "./src/icons/svg/dashbord/rate2.svg",
	"./dashbord/rate3.svg": "./src/icons/svg/dashbord/rate3.svg",
	"./dashbord/rate4.svg": "./src/icons/svg/dashbord/rate4.svg",
	"./dashbord/rate5.svg": "./src/icons/svg/dashbord/rate5.svg",
	"./dashbord/rate6.svg": "./src/icons/svg/dashbord/rate6.svg",
	"./dashbord/rate7.svg": "./src/icons/svg/dashbord/rate7.svg",
	"./dashbord/rate8.svg": "./src/icons/svg/dashbord/rate8.svg",
	"./dashbord/rate9.svg": "./src/icons/svg/dashbord/rate9.svg",
	"./dashbord/red-trend-line.svg": "./src/icons/svg/dashbord/red-trend-line.svg",
	"./dashbord/send-mail.svg": "./src/icons/svg/dashbord/send-mail.svg",
	"./dashbord/smartBusinessOpportunitNew.svg": "./src/icons/svg/dashbord/smartBusinessOpportunitNew.svg",
	"./dashbord/take-foreign-trade-courses.svg": "./src/icons/svg/dashbord/take-foreign-trade-courses.svg",
	"./dashbord/three-points.svg": "./src/icons/svg/dashbord/three-points.svg",
	"./dashbord/view-trend-analysis.svg": "./src/icons/svg/dashbord/view-trend-analysis.svg",
	"./dashbord/wechat-mini-program.svg": "./src/icons/svg/dashbord/wechat-mini-program.svg",
	"./dataSourceCount.svg": "./src/icons/svg/dataSourceCount.svg",
	"./dd.svg": "./src/icons/svg/dd.svg",
	"./deepCustomerlizedReportCount.svg": "./src/icons/svg/deepCustomerlizedReportCount.svg",
	"./delete.svg": "./src/icons/svg/delete.svg",
	"./deleteIcon.svg": "./src/icons/svg/deleteIcon.svg",
	"./desc-icon.svg": "./src/icons/svg/desc-icon.svg",
	"./download-icon.svg": "./src/icons/svg/download-icon.svg",
	"./download.svg": "./src/icons/svg/download.svg",
	"./downloadCount.svg": "./src/icons/svg/downloadCount.svg",
	"./downloadTradeCount.svg": "./src/icons/svg/downloadTradeCount.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./empty.svg": "./src/icons/svg/empty.svg",
	"./errorUrl.svg": "./src/icons/svg/errorUrl.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./export.svg": "./src/icons/svg/export.svg",
	"./exueker2.svg": "./src/icons/svg/exueker2.svg",
	"./facebook.svg": "./src/icons/svg/facebook.svg",
	"./fail.svg": "./src/icons/svg/fail.svg",
	"./filter_icon.svg": "./src/icons/svg/filter_icon.svg",
	"./finish.svg": "./src/icons/svg/finish.svg",
	"./full-times.svg": "./src/icons/svg/full-times.svg",
	"./goIn.svg": "./src/icons/svg/goIn.svg",
	"./google-website.svg": "./src/icons/svg/google-website.svg",
	"./googleplus.svg": "./src/icons/svg/googleplus.svg",
	"./grid-rectangle.svg": "./src/icons/svg/grid-rectangle.svg",
	"./gt5.svg": "./src/icons/svg/gt5.svg",
	"./gt6.svg": "./src/icons/svg/gt6.svg",
	"./guanbi.svg": "./src/icons/svg/guanbi.svg",
	"./handled.svg": "./src/icons/svg/handled.svg",
	"./head.svg": "./src/icons/svg/head.svg",
	"./hebing.svg": "./src/icons/svg/hebing.svg",
	"./hide-back-top.svg": "./src/icons/svg/hide-back-top.svg",
	"./home-icon1.svg": "./src/icons/svg/home-icon1.svg",
	"./home-icon2.svg": "./src/icons/svg/home-icon2.svg",
	"./home-icon3.svg": "./src/icons/svg/home-icon3.svg",
	"./home-icon4.svg": "./src/icons/svg/home-icon4.svg",
	"./home-icont1.svg": "./src/icons/svg/home-icont1.svg",
	"./home-icont2.svg": "./src/icons/svg/home-icont2.svg",
	"./home-icont3.svg": "./src/icons/svg/home-icont3.svg",
	"./home-icont4.svg": "./src/icons/svg/home-icont4.svg",
	"./hoovers.svg": "./src/icons/svg/hoovers.svg",
	"./hot.svg": "./src/icons/svg/hot.svg",
	"./import.svg": "./src/icons/svg/import.svg",
	"./importCompanyCount.svg": "./src/icons/svg/importCompanyCount.svg",
	"./increase.svg": "./src/icons/svg/increase.svg",
	"./industryCount.svg": "./src/icons/svg/industryCount.svg",
	"./industryTypeCount.svg": "./src/icons/svg/industryTypeCount.svg",
	"./ladingBill.svg": "./src/icons/svg/ladingBill.svg",
	"./lastUpdateData.svg": "./src/icons/svg/lastUpdateData.svg",
	"./left-arrow.svg": "./src/icons/svg/left-arrow.svg",
	"./leget1.svg": "./src/icons/svg/leget1.svg",
	"./linkedin.svg": "./src/icons/svg/linkedin.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./location.svg": "./src/icons/svg/location.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./main.svg": "./src/icons/svg/main.svg",
	"./melark.svg": "./src/icons/svg/melark.svg",
	"./merge.svg": "./src/icons/svg/merge.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./more-icon.svg": "./src/icons/svg/more-icon.svg",
	"./msg.svg": "./src/icons/svg/msg.svg",
	"./new-jiaobiao.svg": "./src/icons/svg/new-jiaobiao.svg",
	"./new-tobottom.svg": "./src/icons/svg/new-tobottom.svg",
	"./new.svg": "./src/icons/svg/new.svg",
	"./no-auth.svg": "./src/icons/svg/no-auth.svg",
	"./no-data.svg": "./src/icons/svg/no-data.svg",
	"./nodata.svg": "./src/icons/svg/nodata.svg",
	"./num.svg": "./src/icons/svg/num.svg",
	"./other.svg": "./src/icons/svg/other.svg",
	"./paySuccess.svg": "./src/icons/svg/paySuccess.svg",
	"./pdf-icon.svg": "./src/icons/svg/pdf-icon.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./plus.svg": "./src/icons/svg/plus.svg",
	"./pro.svg": "./src/icons/svg/pro.svg",
	"./product.svg": "./src/icons/svg/product.svg",
	"./purchaser.svg": "./src/icons/svg/purchaser.svg",
	"./question.svg": "./src/icons/svg/question.svg",
	"./ratio.svg": "./src/icons/svg/ratio.svg",
	"./reason-why.svg": "./src/icons/svg/reason-why.svg",
	"./redmsg.svg": "./src/icons/svg/redmsg.svg",
	"./refresh.svg": "./src/icons/svg/refresh.svg",
	"./right-arrow.svg": "./src/icons/svg/right-arrow.svg",
	"./rightUrl.svg": "./src/icons/svg/rightUrl.svg",
	"./rounded-facebook.svg": "./src/icons/svg/rounded-facebook.svg",
	"./rounded-linkedin.svg": "./src/icons/svg/rounded-linkedin.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./searchlist.svg": "./src/icons/svg/searchlist.svg",
	"./small.svg": "./src/icons/svg/small.svg",
	"./smartBusinessOpportunit.svg": "./src/icons/svg/smartBusinessOpportunit.svg",
	"./sse.svg": "./src/icons/svg/sse.svg",
	"./success.svg": "./src/icons/svg/success.svg",
	"./suo.svg": "./src/icons/svg/suo.svg",
	"./supplier.svg": "./src/icons/svg/supplier.svg",
	"./supply.svg": "./src/icons/svg/supply.svg",
	"./svip-customer-service.svg": "./src/icons/svg/svip-customer-service.svg",
	"./svip-en.svg": "./src/icons/svg/svip-en.svg",
	"./switch.svg": "./src/icons/svg/switch.svg",
	"./tendency.svg": "./src/icons/svg/tendency.svg",
	"./tip.svg": "./src/icons/svg/tip.svg",
	"./tipT.svg": "./src/icons/svg/tipT.svg",
	"./tipl.svg": "./src/icons/svg/tipl.svg",
	"./tips.svg": "./src/icons/svg/tips.svg",
	"./tis.svg": "./src/icons/svg/tis.svg",
	"./tishi.svg": "./src/icons/svg/tishi.svg",
	"./trade/add-more-card.svg": "./src/icons/svg/trade/add-more-card.svg",
	"./trade/asc-sort-icon.svg": "./src/icons/svg/trade/asc-sort-icon.svg",
	"./trade/auto-width.svg": "./src/icons/svg/trade/auto-width.svg",
	"./trade/customer-active.svg": "./src/icons/svg/trade/customer-active.svg",
	"./trade/customer.svg": "./src/icons/svg/trade/customer.svg",
	"./trade/delete-all-search.svg": "./src/icons/svg/trade/delete-all-search.svg",
	"./trade/delete-blue-icon.svg": "./src/icons/svg/trade/delete-blue-icon.svg",
	"./trade/desc-sort-icon.svg": "./src/icons/svg/trade/desc-sort-icon.svg",
	"./trade/detail-search-icon.svg": "./src/icons/svg/trade/detail-search-icon.svg",
	"./trade/down-arrown.svg": "./src/icons/svg/trade/down-arrown.svg",
	"./trade/excel-trade.svg": "./src/icons/svg/trade/excel-trade.svg",
	"./trade/fixed-position-black.svg": "./src/icons/svg/trade/fixed-position-black.svg",
	"./trade/fullscreenExit.svg": "./src/icons/svg/trade/fullscreenExit.svg",
	"./trade/gongshang.svg": "./src/icons/svg/trade/gongshang.svg",
	"./trade/left-icon.svg": "./src/icons/svg/trade/left-icon.svg",
	"./trade/line-active.svg": "./src/icons/svg/trade/line-active.svg",
	"./trade/line.svg": "./src/icons/svg/trade/line.svg",
	"./trade/line2-active.svg": "./src/icons/svg/trade/line2-active.svg",
	"./trade/line2.svg": "./src/icons/svg/trade/line2.svg",
	"./trade/lines-active.svg": "./src/icons/svg/trade/lines-active.svg",
	"./trade/lines.svg": "./src/icons/svg/trade/lines.svg",
	"./trade/list-search-icon.svg": "./src/icons/svg/trade/list-search-icon.svg",
	"./trade/next-icon.svg": "./src/icons/svg/trade/next-icon.svg",
	"./trade/position-arrow-down.svg": "./src/icons/svg/trade/position-arrow-down.svg",
	"./trade/position-arrow-up.svg": "./src/icons/svg/trade/position-arrow-up.svg",
	"./trade/precise-query-active-icon.svg": "./src/icons/svg/trade/precise-query-active-icon.svg",
	"./trade/precise-query-icon.svg": "./src/icons/svg/trade/precise-query-icon.svg",
	"./trade/prev-icon.svg": "./src/icons/svg/trade/prev-icon.svg",
	"./trade/right-arrow-icon.svg": "./src/icons/svg/trade/right-arrow-icon.svg",
	"./trade/right-icon.svg": "./src/icons/svg/trade/right-icon.svg",
	"./trade/screen-active.svg": "./src/icons/svg/trade/screen-active.svg",
	"./trade/screen.svg": "./src/icons/svg/trade/screen.svg",
	"./trade/set-width.svg": "./src/icons/svg/trade/set-width.svg",
	"./trade/supply-en.svg": "./src/icons/svg/trade/supply-en.svg",
	"./trade/switch-opend.svg": "./src/icons/svg/trade/switch-opend.svg",
	"./trade/table-sort.svg": "./src/icons/svg/trade/table-sort.svg",
	"./trade/timeLocked.svg": "./src/icons/svg/trade/timeLocked.svg",
	"./trade/timeUnlocked.svg": "./src/icons/svg/trade/timeUnlocked.svg",
	"./trade/to-bottom-icon.svg": "./src/icons/svg/trade/to-bottom-icon.svg",
	"./trade/to-top-icon.svg": "./src/icons/svg/trade/to-top-icon.svg",
	"./trade/trade-checked.svg": "./src/icons/svg/trade/trade-checked.svg",
	"./trade/translate-edit.svg": "./src/icons/svg/trade/translate-edit.svg",
	"./trade/trend-add.svg": "./src/icons/svg/trade/trend-add.svg",
	"./trade/trend-balance.svg": "./src/icons/svg/trade/trend-balance.svg",
	"./trade/trend-sub.svg": "./src/icons/svg/trade/trend-sub.svg",
	"./trade/unchecked.svg": "./src/icons/svg/trade/unchecked.svg",
	"./tradeData.svg": "./src/icons/svg/tradeData.svg",
	"./trend.svg": "./src/icons/svg/trend.svg",
	"./trend/amount-china.svg": "./src/icons/svg/trend/amount-china.svg",
	"./trend/chart-map.svg": "./src/icons/svg/trend/chart-map.svg",
	"./trend/chart-pie.svg": "./src/icons/svg/trend/chart-pie.svg",
	"./trend/chart-treemap.svg": "./src/icons/svg/trend/chart-treemap.svg",
	"./trend/download-icon.svg": "./src/icons/svg/trend/download-icon.svg",
	"./trend/exporter.svg": "./src/icons/svg/trend/exporter.svg",
	"./trend/importer.svg": "./src/icons/svg/trend/importer.svg",
	"./trend/refresh-icon.svg": "./src/icons/svg/trend/refresh-icon.svg",
	"./trend/topCountry.svg": "./src/icons/svg/trend/topCountry.svg",
	"./trend/tradeGap.svg": "./src/icons/svg/trend/tradeGap.svg",
	"./twitter.svg": "./src/icons/svg/twitter.svg",
	"./type-checked.svg": "./src/icons/svg/type-checked.svg",
	"./unchecked-icon.svg": "./src/icons/svg/unchecked-icon.svg",
	"./undone.svg": "./src/icons/svg/undone.svg",
	"./uniE010.svg": "./src/icons/svg/uniE010.svg",
	"./uninterested.svg": "./src/icons/svg/uninterested.svg",
	"./videoL.svg": "./src/icons/svg/videoL.svg",
	"./view.svg": "./src/icons/svg/view.svg",
	"./vip-tips.svg": "./src/icons/svg/vip-tips.svg",
	"./vip/白银.svg": "./src/icons/svg/vip/白银.svg",
	"./vip/白银先行.svg": "./src/icons/svg/vip/白银先行.svg",
	"./vip/钻石.svg": "./src/icons/svg/vip/钻石.svg",
	"./vip/铂金.svg": "./src/icons/svg/vip/铂金.svg",
	"./vip/黄金.svg": "./src/icons/svg/vip/黄金.svg",
	"./vip/黄金先行.svg": "./src/icons/svg/vip/黄金先行.svg",
	"./warning.svg": "./src/icons/svg/warning.svg",
	"./wenhao.svg": "./src/icons/svg/wenhao.svg",
	"./wx.svg": "./src/icons/svg/wx.svg",
	"./xiaz.svg": "./src/icons/svg/xiaz.svg",
	"./xiazEn.svg": "./src/icons/svg/xiazEn.svg",
	"./xj.svg": "./src/icons/svg/xj.svg",
	"./yangben-en.svg": "./src/icons/svg/yangben-en.svg",
	"./yangben.svg": "./src/icons/svg/yangben.svg",
	"./yisou3.svg": "./src/icons/svg/yisou3.svg",
	"./youtube.svg": "./src/icons/svg/youtube.svg",
	"./ywst.svg": "./src/icons/svg/ywst.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync recursive \\.svg$";